import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import { notify } from "./utils/notify";

const appUrl = process.env.REACT_APP_URL;
const panelUrl = process.env.REACT_APP_PANEL_URL;
const apiUrl = process.env.REACT_APP_API_URL;
const cookieDomain = process.env.REACT_APP_COOKIE_DOMAIN;

const buildCookie = (value, maxAgeAttr) => {
  const isSecure = window.location.protocol === "https:";
  const parts = [`auth_token=${value}`, "path=/", maxAgeAttr, "SameSite=Lax"];
  if (cookieDomain) parts.push(`domain=${cookieDomain}`);
  if (isSecure) parts.push("Secure");
  return parts.filter(Boolean).join("; ");
};

// Función para manejar expiración de token
const handleTokenExpiration = () => {
  localStorage.removeItem("auth_token");
  document.cookie = buildCookie("", "expires=Thu, 01 Jan 1970 00:00:00 GMT");
  notify.warning("Tu sesión ha expirado. Serás redirigido al login.");
  // Pequeño delay para que el toast se vea antes del redirect.
  setTimeout(() => {
    window.location.href = `${panelUrl}/auth/login`;
  }, 1400);
};

// Configurar interceptor de fetch
const setupFetchInterceptor = () => {
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const [input, init = {}] = args;
    const url = typeof input === 'string' ? input : input.url;
    const headers = new Headers(init.headers || {});


    const newInit = {
      ...init,
      headers,
      credentials: 'include'
    };

    try {
      const response = await originalFetch(input, newInit);

      if (response.status === 401 || response.status === 403) {
        handleTokenExpiration();
      }

      return response;
    } catch (error) {
      console.error("Error en la solicitud:", error);
      throw error;
    }
  };
};

// Configuración inicial al cargar la página
document.addEventListener("DOMContentLoaded", () => {
  // Configurar interceptor
  setupFetchInterceptor();

  // Obtener token de la URL
  const urlParams = new URLSearchParams(window.location.search);
  const tokenFromUrl = urlParams.get("token");
  const sessionIdFromUrl = urlParams.get("session_id");
  
  if (tokenFromUrl) {
    // Guardar en localStorage
    localStorage.setItem("auth_token", tokenFromUrl);

    // Guardar en cookie (domain configurable por REACT_APP_COOKIE_DOMAIN)
    document.cookie = buildCookie(tokenFromUrl, "max-age=3600");

    // Limpiar la URL
    console.log("Token recibido desde URL:", tokenFromUrl);
  }
  
  if (sessionIdFromUrl) {
     sessionStorage.setItem("resume_session", sessionIdFromUrl);

  }
  
  if (tokenFromUrl || sessionIdFromUrl) {
    window.history.replaceState({}, "", window.location.pathname);
  }
  
  // Verificar si tenemos token
  const token = localStorage.getItem('auth_token');
  if (!token) {
    console.error("No se encontró token de autenticación");
    // Redirigir después de un breve retraso
    setTimeout(() => {
      window.location.href = `${panelUrl}/auth/login`;
    }, 1000);
  }
}); // ← Este cierra correctamente el DOMContentLoaded

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);